import { AxiosInstance } from "axios";

export default (httpClient: AxiosInstance) => ({
    // Listar: async (pIdProfissional: number, pData: string) => {
    //     const response = await httpClient.get(`/Agenda/agendaListarProcedimentoSala?pIdProfissional=${pIdProfissional}&pDtAgenda=${pData}`);
    //     let erros = null;
    //     if (!response.data) {
    //         erros = {
    //             status: response.request.status,
    //             statusText: response.request.statusText
    //         };
    //     }
    //     return {
    //         data: response.data,
    //         erros: erros
    //     };
    // },
    Listar: async (pIdProfissional: number, pData: string) => {
        const response = await httpClient.get(`/Agenda/agendaListar?pIdProfissional=${pIdProfissional}&pDtAgenda=${pData}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ProfissionalAgendaExiste: async (pIdProfissional: number, pData: number) => {
        // console.log(`/Profissional/existeAgenda?pIdProfissional=${pIdProfissional}&Dia=${pData}`);
        const response = await httpClient.get(`/Profissional/existeAgenda?pIdProfissional=${pIdProfissional}&Dia=${pData}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ListarPorId: async (pId: number) => {
        const response = await httpClient.get(`/Agenda/id?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Inserir: async (pObj: Record<string, unknown>) => {
        const response = await httpClient.post(`/Agenda/inserir`, pObj);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Alterar: async (pObj: Record<string, unknown>) => {
        const response = await httpClient.post(`/Agenda/alterar`, pObj);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Excluir: async (pId: number) => {
        const response = await httpClient.post(`/Agenda/excluir?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Aguardando: async (pIdAgendamento: number, pHora: string) => {
        const response = await httpClient.post(`/Agenda/aguardando?pId=${pIdAgendamento}&pHora=${pHora}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Atendimento: async (pIdAgendamento: number) => {
        const response = await httpClient.post(`/Agenda/atendimento?pId=${pIdAgendamento}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Finalizado: async (pIdAgendamento: number) => {
        const response = await httpClient.post(`/Agenda/finalizando?pId=${pIdAgendamento}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Faltou: async (pIdAgendamento: number) => {
        const response = await httpClient.post(`/Agenda/faltou?pId=${pIdAgendamento}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Desmarcado: async (pIdAgendamento: number) => {
        const response = await httpClient.post(`/Agenda/desmarcado?pId=${pIdAgendamento}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Exibir: async () => {
        const response = await httpClient.get(`/Agenda/exibir`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    AgendaPacienteNome: async (pIdAgendamento: number) => {
        const response = await httpClient.get(`/Agenda/Paciente?pIdAgenda=${pIdAgendamento}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    AgendaProfissionalNome: async (pIdAgendamento: number) => {
        const response = await httpClient.get(`/Agenda/Profissional?pIdAgenda=${pIdAgendamento}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
});